import { BaseError } from '@dynamic-labs-sdk/client';

export class NotTronProviderError extends BaseError {
  public readonly providerKey: string;

  constructor(params: { providerKey: string }) {
    super({
      cause: null,
      code: 'not_tron_provider_error',
      docsUrl: null,
      name: 'NotTronProviderError',
      shortMessage: 'Provider is not a Tron wallet provider',
    });

    this.providerKey = params.providerKey;
  }
}
